<div class="ai-smart-summary" *transloco="let t; prefix: 'ai-assistant'">
  @if (title()) {
    <div class="ai-smart-summary__title">{{ title() }}</div>
  }
  @if (summary()) {
    <div class="ai-smart-summary__summary">{{ summary() }}</div>
  }
  @if (keyFindings().length) {
    <ul class="ai-smart-summary__findings">
      @for (finding of keyFindings(); track $index) {
        <li class="ai-smart-summary__finding">{{ finding }}</li>
      }
    </ul>
  }
  @if (hasVerbatims()) {
    <button type="button" class="ai-smart-summary__verbatims-toggle" (click)="toggleVerbatims()">
      @if (verbatimsExpanded()) {
        {{ t('smart-summary-hide-examples') }}
      } @else {
        {{ t('smart-summary-show-examples', { count: verbatimExamples().length }) }}
      }
    </button>
    @if (verbatimsExpanded()) {
      <div class="ai-smart-summary__verbatims">
        @for (v of verbatimExamples(); track $index) {
          <div class="ai-smart-summary__verbatim">
            @if (v.sentiment) {
              <span
                class="ai-smart-summary__verbatim-sentiment"
                [class]="sentimentClass(v.sentiment)"
              >
                {{ v.sentiment }}
              </span>
            }
            <span class="ai-smart-summary__verbatim-text">"{{ v.text }}"</span>
          </div>
        }
      </div>
    }
  }
</div>
